// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"87c087532c62faf1119a","3180":"7dfc1afd807aaeebec05","9635":"7b5b8f90d562cabb0d4b"}[chunkId] + ".css";
};